import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ChevronRight = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { transform: "translate(12.000000, 12.000000) rotate(-360.000000) translate(-12.000000, -12.000000) ", points: "8 7.4 9.51351351 6 16 12 9.51351351 18 8 16.6 12.972973 12" })));
};
export default ChevronRight;
